import { Row } from '@tanstack/react-table';
import PencilSquare from 'assets/images/icons/pencil-square.svg?react';
import {
  IntegrationStatus,
  InternalIntegrationSetting,
} from 'models/InternalIntegrationSetting';
import useEditRateMultiplierModal from 'pages/channels/components/modals/editRateMultiplier/useEditRateMultiplierModal';
import { StyledBadge, StyledButton } from './RateMultiplierCell.styles';

const RateMultiplierCell = ({
  row,
}: {
  row: Row<InternalIntegrationSetting>;
}) => {
  const { openEditRateMultiplierModal } = useEditRateMultiplierModal();
  const integrationSettings = row.original;
  const { rateMultiplier, status } = integrationSettings.agencySettings;
  const { rateMultiplierSupported } = integrationSettings.integration;
  const isActive = status === IntegrationStatus.ACTIVE;
  const value = `${rateMultiplier ?? 0}%`;

  if (!rateMultiplierSupported) {
    return null;
  }

  return (
    <StyledButton
      bsStyle="link"
      data-testid="rate-multiplier-button"
      disabled={!isActive}
      onClick={(e) => {
        e.stopPropagation();
        openEditRateMultiplierModal({ integrationSettings });
      }}
    >
      <StyledBadge isActive={isActive}>{value}</StyledBadge>
      {isActive && <PencilSquare className="pencil-square-icon" />}
    </StyledButton>
  );
};

export default RateMultiplierCell;
